// Detect the current browser's IANA timezone
export function detectTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

// Convert a local date+time (in a specific IANA timezone) to a UTC Date object.
// Uses the "double-format" offset trick — no external libraries needed.
// dateStr: "YYYY-MM-DD", timeStr: "HH:MM", timezone: "America/New_York"
export function localToUTC(dateStr, timeStr, timezone) {
  const asUTC = new Date(`${dateStr}T${timeStr}:00Z`);

  // Format that same UTC instant in the target timezone
  const localStr = new Intl.DateTimeFormat('sv-SE', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
    .format(asUTC)
    .replace(' ', 'T');

  // Compute the UTC offset for that timezone at that moment,
  // then shift the original instant by that offset.
  const offset = new Date(localStr + 'Z').getTime() - asUTC.getTime();
  return new Date(asUTC.getTime() - offset);
}

// Return "YYYY-MM-DD" for a UTC value displayed in the given IANA timezone.
// Accepts a Firebase Timestamp (has .toDate()) or any value new Date() can parse.
export function getDateInTimezone(utcValue, timezone) {
  const date = utcValue?.toDate ? utcValue.toDate() : new Date(utcValue);
  return date.toLocaleDateString('sv-SE', { timeZone: timezone }); // always YYYY-MM-DD
}

// Return "HH:MM" (24-hour) for a UTC value displayed in the given IANA timezone.
export function getTimeInTimezone(utcValue, timezone) {
  const date = utcValue?.toDate ? utcValue.toDate() : new Date(utcValue);
  return date.toLocaleString('en-GB', {
    timeZone: timezone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
